import { Modal, Box, Grid, Typography, FormControl, Select, MenuItem, FormHelperText, TextField, CircularProgress, Button, IconButton} from "@mui/material";
import { useGetTransactionDetailsQuery } from "../../../../../services/PaymentToolApi";
import { createErrorMessage } from "../../../../../utils/index";
import { useMemo, useState } from "react";
import { useNotification } from '../../../../../context/NotificationContext';
import { createAddErrorTransactionValidationSchema } from "../../../../../validations/PaymentTool/addNewErrorTransactionValidation";
import { useAddErrorTrackingMutation, useGetErrorReasonsQuery } from "../../../../../services/errorTrackingApi";
import CopyToClipBoard from "./CopyToClipBoard";
const ModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 650,
  padding: '1em',
  bgcolor: 'background.paper',
  borderRadius: '1em',
  boxShadow: 24,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export function AddErrorTransactionModal({modalIsOpen, setModalIsOpen, selectedTransaction}){

  const { showNotification } = useNotification();
  
  const transactionID= selectedTransaction?.transactionID;
  const {data: transactionDetails, isLoading: transactionDetailsIsLoading, error: transactionDetailsError} = useGetTransactionDetailsQuery({transactionID, fields: ['orderNumber']}, {skip: !transactionID});
  const {data: transactionReasons, isLoading: transactionReasonsIsLoading, isError: transactionReasonsIsError, error: transactionReasonsError, isFetching: transactionReasonsIsFetching} = useGetErrorReasonsQuery();
  
  const [sendNewErrorTracking, {isLoading: sendNewErrorTrackingIsLoading, isError: sendNewErrorTrackingIsError, error: sendNewErrorTrackingError}] = useAddErrorTrackingMutation();
  const [formState, setFormState] = useState({
    formValues: {
      transactionReasonID: '',
      notesForBee: '',
      notesForAdmin: ''
    },
    formErrors: []
  });

  function handleClose(){
    setModalIsOpen(false);

    setFormState({
      formValues: {},
      formErrors: {}
    });
  }

  function ModalHeader(){
    return(
      <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
          <Typography align="left" color="primary" style={{ fontWeight: 'bold' }}>Add New Bee Error</Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography align="right">
            <strong>Transaction Id:</strong> {transactionID}
            <CopyToClipBoard text={transactionID} />
          </Typography>
          <Typography align="right">
            {
              transactionDetailsError ?
                <p>{createErrorMessage(transactionDetailsError)}</p>
              :
              <>
                <strong>Order Number:</strong> {transactionDetailsIsLoading ? 'Loading...' : 
                <>{transactionDetails?.orderNumber || "-"}<CopyToClipBoard text={transactionDetails?.orderNumber} /></>
                }
              </>
            }
          </Typography>
        </Grid>
      </Grid>
    )
  }

  function handleTransactionSave(formValues){
    const newErrorTracking = {
      errorReasonID: formValues.transactionReasonID,
      notesForBee: formValues.notesForBee,
      notesForAdmin: formValues.notesForAdmin,
      relatedTransactionID: transactionID
    };

    sendNewErrorTracking(newErrorTracking)
      .unwrap()
      .then(() => {
        showNotification('Error tracking created successfully!', 'success');
        handleClose();
      })
      .catch((error) => {
        showNotification(createErrorMessage(error), 'error');
      });

  }

  const errorTransactionValidation = useMemo(() => createAddErrorTransactionValidationSchema(transactionReasons), [transactionReasons]);
  async function handleSubmit(event){
    event.preventDefault();
    console.log('Submit: ' , formState.formValues);
    setFormState({...formState, formErrors: {}});
    try {
      // Validate form values against the chosen schema
      await errorTransactionValidation.validate(formState.formValues, { abortEarly: false });
      // If validation is successful, proceed to save the transaction
      handleTransactionSave(formValues);
    } catch (err) {
      // Handle validation errors
      console.log(err);
      const errors = {};
      err.inner.forEach((error) => {
        errors[error.path] = error.message;
      });
      setFormState((prevState) => ({
        ...prevState,
        formErrors: errors,
      }));
    }
  }

  const formErrors = formState.formErrors;
  const formValues= formState.formValues;

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormState((prevState) => ({
      ...prevState,
      formValues: {
        ...prevState.formValues,
        [name]: value,
      },
    }));
  };

  const transactionAdjustmentIsLoading= false;

  return (
    <>
    
      <Modal
        open={modalIsOpen}
        onClose={handleClose}
      >
        <Box sx={ModalStyle}>
          <ModalHeader />

          <form noValidate onSubmit={handleSubmit}>
            {/* SELECT TRASANCTION REASON  */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Reason (Visible for Bee)</p>
            <FormControl  sx={{ height: '41px', width: '100%', marginBottom: '2em'}} error={!!formErrors.transactionReasonID}>
              <Select
                sx={{ height: '41px', width: '100%' }}
                name="transactionReasonID"
                value={formValues.transactionReasonID}
                onChange={handleChange}
                MenuProps={MenuProps}
              >
                { (transactionReasons || []).map((reason) => (
                  <MenuItem key={reason.id} value={reason.id}>{reason.name}</MenuItem>
                )) }
              </Select>
              <FormHelperText>{formErrors.transactionReasonID}</FormHelperText>
            </FormControl>

            {/* WRITE BEE COMMENTS */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Reason Details (Visible for Bee)</p>
            <TextField
              multiline
              rows={4}
              name="notesForBee"
              value={formValues.notesForBee}
              onChange={handleChange}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
              error={!!formErrors.notesForBee}
              helperText={formErrors.notesForBee}
            />

            {/* WRITE ADMIN COMMENTS */}
            <p style={{ fontSize: 'var(--p2)', margin: '0 0 0.25em 0' }}>Internal Notes (Visible only for Admins)</p>
            <TextField
              multiline
              rows={4}
              name="notesForAdmin"
              value={formValues.notesForAdmin}
              onChange={handleChange}
              sx={{ width: '100%', margin: '0 0 1em 0' }}
              error={!!formErrors.notesForAdmin}
              helperText={formErrors.notesForAdmin}
            />

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant='contained' color='secondary' sx={{ minWidth: '100px', margin:'0 1em 0 0' }} name="cancelButton" onClick={handleClose}>Cancel</Button>
              <Button disabled={sendNewErrorTrackingIsLoading} variant='contained' type="submit" name="acceptButton" color='primary' sx={{ minWidth: '100px' }} >{ transactionAdjustmentIsLoading || sendNewErrorTrackingIsLoading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "OK" }</Button>
            </div>

          </form>
        </Box>
      </Modal>
    </>
  )
}